"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogSpinner = exports.spinnerDialogType = void 0;
const DialogBase_1 = require("./DialogBase");
const MemoizedString_1 = require("./MemoizedString");
exports.spinnerDialogType = "SPINNER";
class DialogSpinner extends DialogBase_1.DialogBase {
    get message() {
        return this.memoizedMessage.val;
    }
    set message(val) {
        this.memoizedMessage.val = val;
    }
    set isOpen(open) {
        if (open && this.createdAt === undefined) {
            this.createdAt = Date.now();
        }
        this.memoizedOpen.val = open;
    }
    get isOpen() {
        return this.memoizedOpen.val;
    }
    constructor(title, message) {
        super(exports.spinnerDialogType);
        this.type = exports.spinnerDialogType;
        this.mininumuLifespan = 2000;
        this.close = () => {
            if (this.createdAt === undefined) {
                this.isOpen = false;
                return;
            }
            const timeAlive = Date.now() - this.createdAt;
            const timeleft = this.mininumuLifespan - timeAlive;
            if (timeleft <= 0) {
                this.isOpen = false;
            }
            else {
                setTimeout(() => {
                    this.isOpen = false;
                }, timeleft);
            }
        };
        this.memoizedMessage = new MemoizedString_1.MemoizedString(message, this.notify);
        this.title = title;
    }
}
exports.DialogSpinner = DialogSpinner;
